import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import cn from 'classnames'

import { GridTile } from '../../components'
import styles from './student_grid.scss'
import buildGrid, { filterGrid } from 'helpers/grid_builder'

class StudentGrid extends PureComponent {

	constructor(props) {
		super(props)
		this.state = {
			cols: 0,
			rows: 0,
			raw_card_width: 0,
			card_width: 0,
			card_height: 0,
			margin_width: 0,
			margin_height: 0,
			grid_width: 0,
			grid_height: 0,
			font_size: '0px',

		}
	}

	componentDidMount() {
		// When inside the preview modal this timeout is needed so the math
		// to make the grid takes the correct values of the container
		setTimeout(() => {
			this.handleWindowResize()
		}, 0)
	}

	render() {
		return (
			<div
				styleName={cn({
					grid: true,
					'grid--disabled': this.props.disabled,
				})}
				ref={el => this.element = el}
			>
				<div
					style={{
						position: 'absolute',
						left: this.state.margin_width / 2 + 'px',
						top: Math.max(0, this.state.margin_height / 2) + 'px',
						width: this.state.grid_width,
						height: this.state.grid_height + 'px'}}
				>
					{this.props.tiles.map((content, key) => (
						<GridTile
							content={content}
							key={key}
							index={key}
							should_animate_card={this.props.should_animate_cards}
							activate={this.props.activate}
							card_width={this.state.card_width}
							card_height={this.state.card_height}
							tileClickHandler={this.props.tileClickHandler}
							zoomClickHandler={this.props.tileZoomClickHandler}
							tileLoadedHandler={this.props.tileLoadedHandler}
							font_size={this.state.font_size}
							assetsPath={this.props.assetsPath}
						/>
					))}
				</div>
			</div>
		)
	}

	//This method removes empty rows while number of tiles if lower than (cols * rows - 1)
	adjustRowsCount(card_data, TILE_COUNT) {
		let rowsCount = card_data.rows
		const colsCount = card_data.cols
		while (rowsCount * colsCount >= TILE_COUNT) {
			rowsCount -= 1
		}
		rowsCount += 1
		card_data.rows = rowsCount
		return card_data
	}

	handleWindowResize = () => {
		let results = []
		//Using offsetWidth instead of clientWidth because of scrollbars
		let GRID_WIDTH = this.element.offsetWidth
		const GRID_HEIGHT = this.element.clientHeight
		if (GRID_WIDTH === 0 || GRID_HEIGHT === 0) {
			return
		}
		const TILE_COUNT = this.props.tiles.length
		let is_full_width = false
		const CARD_RATIO = 1

		results = buildGrid(GRID_WIDTH, GRID_HEIGHT, TILE_COUNT, CARD_RATIO)

		//Min tile size 120*120
		results = filterGrid(results, 120*120)

		if (results.length === 0) {
			//40px adjust for scrollbar
			GRID_WIDTH -= 25
			is_full_width = true
			const cols = GRID_WIDTH <= 400 ? 1 : 2
			const card_width = GRID_WIDTH / cols
			const card_height = card_width / CARD_RATIO
			results.push({
				width: card_width,
				height: card_height,
				size: card_width * card_height,
				cols,
				rows: Math.ceil(TILE_COUNT / cols),
				score: 0,
			})
		}

		let card_size_data = results[0]
		card_size_data = this.adjustRowsCount(card_size_data, TILE_COUNT)

		const final_grid_height = card_size_data.rows * card_size_data.height
		const final_grid_width = card_size_data.cols * card_size_data.width

		const fontRelativeWidth = is_full_width ?
			GRID_WIDTH <= 400 ? GRID_WIDTH : GRID_WIDTH / 2
			: card_size_data.width

		// This defines the relative font for all tiles sizes.
		// Original size is 40px when tile is 400px. Hence 40 / 400.
		const font_size = fontRelativeWidth * 40 / 400 + 'px'


		this.setState({
			cols: card_size_data.cols,
			rows: card_size_data.rows,
			raw_card_width: card_size_data.width,
			card_width: card_size_data.width + 'px',
			card_height: card_size_data.height + 'px',
			margin_width: GRID_WIDTH - final_grid_width,
			margin_height: GRID_HEIGHT - final_grid_height,
			grid_width: final_grid_width + 'px',
			grid_height: final_grid_height,
			font_size,
		})
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.resize !== this.props.resize) {
			this.handleWindowResize()
		}
	}

}

StudentGrid.propTypes = {
	tiles: PropTypes.array.isRequired,
	onTileClick: PropTypes.func.isRequired,
	onGridLoaded: PropTypes.func,
	disabled: PropTypes.bool,
	should_animate_cards: PropTypes.bool,
	resize: PropTypes.number,
}

StudentGrid.defaultProps = {
	tiles: [],
	onTileClick: () => { },
	onGridLoaded: () => { },
	disabled: false,
	should_animate_cards: true,
	resize: 0,
}

export default CSSModules(StudentGrid, styles, { allowMultiple: true })
